import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import type { MarketApps } from '@/features/Dashboard/types';

import { marketsApi } from './markets.api';

export const marketsOptions = {
  market: (marketId: string | undefined) =>
    queryOptions({
      queryKey: ['market', marketId],
      queryFn: () => marketsApi.getMarket(marketId as string),
      enabled: Boolean(marketId),
      refetchOnWindowFocus: true,
      staleTime: 5 * 60 * 1000
    }),
  widgets: (marketId: string | null) =>
    queryOptions({
      queryKey: ['marketWidgets', marketId],
      queryFn: () => marketsApi.getMarketWidgets(marketId as string),
      enabled: Boolean(marketId),
      refetchOnWindowFocus: true,
      staleTime: 5 * 60 * 1000
    }),
  preview: (template: MarketApps | undefined, enabled = true) =>
    queryOptions({
      queryKey: ['marketPreview', template],
      queryFn: () => marketsApi.previewMarket(template as MarketApps),
      placeholderData: keepPreviousData,
      enabled: Boolean(template && template.length > 0 && enabled),
      refetchOnWindowFocus: true,
      staleTime: 5 * 60 * 1000
    })
};
